import { provider_icon } from './styles.module.scss';

/* eslint-disable max-len */
export const AppleIcon = () => (
  <svg className={provider_icon} viewBox="0 0 24 24" fill="#333">
    <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

export const GoogleIcon = () => (
  <svg className={provider_icon} viewBox="0 0 24 24">
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
    />
  </svg>
);

export const OutlookIcon = () => (
  <svg className={provider_icon} viewBox="0 0 24 24">
    <path
      fill="#0078D4"
      d="M24 7.387v10.478c0 .23-.08.424-.238.576a.806.806 0 0 1-.588.236h-8.174v-8.47l1.6 1.178.4-.546-2-1.476V7.387h8.174c.234 0 .43.078.588.23A.78.78 0 0 1 24 7.387z"
    />
    <path
      fill="#0078D4"
      d="M15 10.207v8.166l-1.2.627H1.2L0 18.373V5.627L1.2 5h12.6l1.2.627v4.58z"
    />
    <path
      fill="#fff"
      d="M7.5 8.5c-1.1 0-2 .4-2.7 1.2-.7.8-1 1.8-1 3s.3 2.2 1 3c.7.8 1.6 1.2 2.7 1.2s2-.4 2.7-1.2c.7-.8 1-1.8 1-3s-.3-2.2-1-3c-.7-.8-1.6-1.2-2.7-1.2zm0 7c-.7 0-1.3-.3-1.7-.8-.4-.6-.6-1.3-.6-2.2s.2-1.6.6-2.2c.4-.5 1-.8 1.7-.8s1.3.3 1.7.8c.4.6.6 1.3.6 2.2s-.2 1.6-.6 2.2c-.4.5-1 .8-1.7.8z"
    />
  </svg>
);

export const Microsoft365Icon = () => (
  <svg className={provider_icon} viewBox="0 0 24 24">
    <rect fill="#F25022" x="1" y="1" width="10" height="10" />
    <rect fill="#7FBA00" x="13" y="1" width="10" height="10" />
    <rect fill="#00A4EF" x="1" y="13" width="10" height="10" />
    <rect fill="#FFB900" x="13" y="13" width="10" height="10" />
  </svg>
);
/* eslint-enable max-len */
